import { injectGlobal } from 'emotion';

import { Direction } from './';
import { ANIMATION_DURATION_MS, animationTransition } from '@joykit/variables/animations';

export namespace animations {
  export const getInitialYTransform = (from: Direction) => `${from === 'bottom' ? '' : '-'}100%`;
  export const getAnimationStates = (from: Direction) => {
    const initialYTransform = getInitialYTransform(from);
    return {
      entering: {
        transform: `translateZ(0.001px) translateY(${initialYTransform})`
      },
      entered: {
        opacity: 1,
        transform: 'translateY(0px)'
      },
      exited: {
        opacity: 0,
        transform: `translateY(${initialYTransform})`
      },
      exiting: {
        opacity: 1,
        transition: `transform ${ANIMATION_DURATION_MS + 200}ms cubic-bezier(0.23, 1, 0.32, 1) 0s`,
        transform: `translateZ(0.0001px) translateY(${initialYTransform})`
      }
    };
  };
}

const directionalClassNames: { from: Direction; className: string }[] = [
  {
    from: 'bottom',
    className: 'slide-up'
  },
  {
    from: 'top',
    className: 'slide-down'
  }
];
directionalClassNames.forEach(({ from, className }) => {
  const animationStates = animations.getAnimationStates(from);

  injectGlobal({
    [`.${className}-enter, .${className}-exit`]: {
      transition: animationTransition('transform'),
      ...animationStates.entering
    },
    [`.${className}-enter-active`]: {
      transition: animationTransition('transform'),
      ...animationStates.entering
    },
    [`.${className}-exit-active`]: {
      transition: animationTransition('transform'),
      ...animationStates.exiting
    },
    [`.${className}-exit-done`]: {
      transition: animationTransition('transform'),
      ...animationStates.exited
    }
  });
});
